import {
	APP_CONF_VARS,
} from '@appConf/vars.conf';
import {
	EnumQueryMethods,
} from '@enums/query.enum';
import {
	GetSpecificationContactsOfferError,
} from '@exceptions/GetSpecificationContactsOfferError';
import {
	GetSpecificationLotsOfferError,
} from '@exceptions/GetSpecificationLotsOfferError';
import {
	GetSpecificationOffersError,
} from '@exceptions/GetSpecificationOffersError';
import {
	GetSpecificationsError,
} from '@exceptions/GetSpecificationsError';
import {
	GetSpecificationStatusError,
} from '@exceptions/GetSpecificationStatusError';
import {
	GetSpecificationUpdatedOfferError,
} from '@exceptions/GetSpecificationUpdatedOfferError';
import {
	PostAssociateOfferError,
} from '@exceptions/PostAssociateOfferError';
import {
	PostDuplicateOffersError,
} from '@exceptions/PostDuplicateOffersError';
import {
	PostOfferSearchError,
} from '@exceptions/PostOfferSearchError';
import {
	PostSpecificationAcceptedUpdatedOfferError,
} from '@exceptions/PostSpecificationAcceptedUpdatedOfferError';
import {
	PostSpecificationIgnoredError,
} from '@exceptions/PostSpecificationIgnoredError';
import {
	PostSpecificationIgnoredUpdatedOfferError,
} from '@exceptions/PostSpecificationIgnoredUpdatedOfferError';
import {
	getURL,
} from '@modules/utils';
import {
	FETCHES,
} from '@routes/fetches';
import {
	customFetcher,
} from './custom-fetch';

export const getSpecification = async (specificationId: number, controller: AbortController) => await customFetcher(getURL(FETCHES.private.specifications.id, {
	':specificationid': specificationId.toString(),
}), {
	...APP_CONF_VARS.request.default,
	headers: {
		'Content-Type': 'application/x-www-form-urlencoded',
	},
	signal: controller.signal,
}).then((resp) => resp.json()).catch(error => {
	throw new GetSpecificationsError(error);
});

export const getSpecificationStatus = async (specificationId: number) => await customFetcher(getURL(FETCHES.private.specifications.status, {
	':specificationid': specificationId.toString(),
}), {
	...APP_CONF_VARS.request.default,
}).then((resp) => resp.json()).catch(error => {
	throw new GetSpecificationStatusError(error);
});

export const getSpecificationUpdatedOffer = async (specificationId: number, offerId: number) => await customFetcher(getURL(FETCHES.private.specifications.updated, {
	':announcementid': offerId.toString(),
	':specificationid': specificationId.toString(),
}), {
	...APP_CONF_VARS.request.default,
}).then((resp) => resp.json()).catch(error => {
	throw new GetSpecificationUpdatedOfferError(error);
});

export const postSpecificationIgnored = async (specificationId: number, offerIds: number[]) => await customFetcher(getURL(FETCHES.private.specifications.ignored, {
	':specificationid': specificationId.toString(),
}), {
	...APP_CONF_VARS.request.default,
	body: JSON.stringify({
		ids: offerIds,
	}),
	method: EnumQueryMethods.POST,
}).then((resp) => resp.json()).catch(error => {
	throw new PostSpecificationIgnoredError(error);
});

export const getPublicOffers = async (specificationId: number) => await customFetcher(getURL(FETCHES.private.specifications.offers, {
	':specificationid': specificationId.toString(),
}), {
	...APP_CONF_VARS.request.default,
}).then((resp) => resp.json()).catch(error => {
	throw new GetSpecificationOffersError(error);
});

export const getContactsOffer = async (offerId: number) => await customFetcher(getURL(FETCHES.private.offers.contacts.__ROOT, {
	':offerid': `${offerId}`,
}), {
	...APP_CONF_VARS.request.default,
}).then((resp) => resp.json()).catch(error => {
	throw new GetSpecificationContactsOfferError(error);
});

export const getLotsOffer = async (offerId: number) => await customFetcher(getURL(FETCHES.private.offers.lots, {
	':offerid': `${offerId}`,
}), {
	...APP_CONF_VARS.request.default,
}).then((resp) => resp.json()).catch(error => {
	throw new GetSpecificationLotsOfferError(error);
});

export const postOfferSearch = async (value: string | number) => await customFetcher(getURL(FETCHES.private.offers.search), {
	...APP_CONF_VARS.request.default,
	body: JSON.stringify({
		full_text: value,
	}),
	method: EnumQueryMethods.POST,
}).then((resp) => resp.json()).catch(error => {
	throw new PostOfferSearchError(error);
});

export const postDuplicateOffers = async (specificationId: number, offerIds: number[]) => await customFetcher(getURL(FETCHES.private.specifications.offers, {
	':specificationid': `${specificationId}`,
}), {
	...APP_CONF_VARS.request.default,
	body: JSON.stringify({
		announcement_ids: offerIds,
	}),
	method: EnumQueryMethods.COPY,
}).then((resp) => resp.json()).catch(error => {
	throw new PostDuplicateOffersError(error);
});

export const postAssociateOffer = async (specificationId: number, publicOfferId: number, privateOfferId: number) => await customFetcher(getURL(FETCHES.private.specifications.associate, {
	':offerid': `${publicOfferId}`,
	':specificationid': `${specificationId}`,
}), {
	...APP_CONF_VARS.request.default,
	body: JSON.stringify({
		private_offer_id: privateOfferId,
	}),
	method: EnumQueryMethods.POST,
}).then((resp) => resp.json()).catch(error => {
	throw new PostAssociateOfferError(error);
});

export const postSpecificationIgnoredUpdatedOffer = async (specificationId: number, offerIds: number[]) => await customFetcher(getURL(FETCHES.private.specifications.update_ignored, {
	':specificationid': specificationId.toString(),
}), {
	...APP_CONF_VARS.request.default,
	body: JSON.stringify({
		ids: offerIds,
	}),
	method: EnumQueryMethods.POST,
}).then((resp) => resp.json()).catch(error => {
	throw new PostSpecificationIgnoredUpdatedOfferError(error);
});

export const postSpecificationAcceptedUpdatedOffer = async (specificationId: number, offerIds: number[]) => await customFetcher(getURL(FETCHES.private.specifications.update_accepted, {
	':specificationid': specificationId.toString(),
}), {
	...APP_CONF_VARS.request.default,
	body: JSON.stringify({
		ids: offerIds,
	}),
	method: EnumQueryMethods.POST,
}).then((resp) => resp.json()).catch(error => {
	throw new PostSpecificationAcceptedUpdatedOfferError(error);
});
